import React, {useState, useEffect, Fragment, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Button, Modal} from 'react-bootstrap';
import {ContentHeader, Loader} from '@app/components';
import {useNavigate, useParams} from 'react-router-dom';
import {BASE_URL, COLUMN_NAMES} from '../../config';
import {DndProvider, useDrag, useDrop} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {TouchBackend} from 'react-dnd-touch-backend';
import {getUserPermission} from '../../utils/helpers';
import {getAllProjectNames} from '../../services/project';
import {AiOutlineArrowDown, AiOutlineArrowUp} from 'react-icons/ai';
import {BsArchive} from 'react-icons/bs';
import {
  getAllUsers,
  getMyProjects,
  getAllTask,
  getIssueByTaskId,
  getUserAllIssues,
  changeColumn,
  archieveTask
} from '../../services/tasks';
import handleStatus from '../../utils/ajax';
import {logoutUser} from '../../store/reducers/auth';
import TaskForm from './TaskForm';
import ViewUpdateTask from './ViewUpdateTask';
import { toast } from 'react-toastify';
const priorties = ['Urgent', 'Medium', 'Low'];

const Tasks = () => {
  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [mode, setMode] = useState('CREATE');
  const [tasks, setTasks] = useState([]);
  const isMobile = window.innerWidth < 600;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const user = useSelector((state: any) => state.auth.currentUser);
  const [searchText, setSearchText] = useState('');
  const [priority, setPriority] = useState('');
  const [userId, setUserId] = useState('');
  const [projectId, setProjectId] = useState('');
  const [searchValues, setSearchValues] = useState({});
  const loggedInId = useSelector(
    (state: any) => state.auth.currentUser.data._id
  );

  useEffect(() => {
    setSearchValues({searchText, priority, userId, projectId});
  }, [searchText, priority, userId, projectId]);

  const {DO_IT, IN_PROGRESS, AWAITING_REVIEW, DONE} = COLUMN_NAMES;

  const getUsers = async () => {
    const resp = await getAllUsers();
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    if (resp.data.ok) {
      setAllUsers(
        resp.data.data.map((user: any) => ({value: user._id, label: user.name}))
      );
    }
  };

  const getProjects = async () => {
    let resp = {};
    if (getUserPermission(user) === 'admin') {
      resp = await getAllProjectNames();
    } else {
      resp = await getMyProjects();
    }

    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

    if (resp.data.ok) {
      setProjects(resp.data.data);
    }
  };

  const setAttachmentsToTasks = async (userTasks) => {
        const allAttachments = userTasks.map((issue) =>
        getIssueByTaskId(issue._id)
      );
      const allAttachmentsData = await Promise.all(allAttachments);
      const allAttachmentsFilterData = allAttachmentsData
        .map((attach) => {
          const attachmentData = attach.data.data;
          const taskId =
            attachmentData.length > 0 ? attachmentData[0].taskId : null;

          return {
            id: taskId,
            data: attachmentData
          };
        })
        .filter((attach) => attach.id !== null);

      const allTasks = userTasks.map((task) => {
        const taskAttachment = allAttachmentsFilterData.find(
          (attachment) => attachment.id === task._id
        );

        return {
          ...task,
          attachments: taskAttachment ? taskAttachment.data : []
        };
      });
      setTasks(allTasks);
  }

  const getTasks = async (query: any) => {
    setShowLoader(true);
    let resp = {};
    if(query.projectId === ""){
      resp = await getUserAllIssues(query);
    }else{
      resp = await getAllTask(query);
    }
     
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    if (resp.data.ok) {
      setTasks(resp.data.data);
      setShowLoader(false);
      await setAttachmentsToTasks(resp.data.data);

      // const allAttachments = resp.data.data.map((issue) =>
      //   getIssueByTaskId(issue._id)
      // );
      // const allAttachmentsData = await Promise.all(allAttachments);
      // const allAttachmentsFilterData = allAttachmentsData
      //   .map((attach) => {
      //     const attachmentData = attach.data.data;
      //     const taskId =
      //       attachmentData.length > 0 ? attachmentData[0].taskId : null;

      //     return {
      //       id: taskId,
      //       data: attachmentData
      //     };
      //   })
      //   .filter((attach) => attach.id !== null);

      // console.log(allAttachmentsFilterData,"allAttachmentsFilterData")
      // const allTasks = resp.data.data.map((task) => {
      //   const taskAttachment = allAttachmentsFilterData.find(
      //     (attachment) => attachment.id === task._id
      //   );

      //   return {
      //     ...task,
      //     attachments: taskAttachment ? taskAttachment.data : []
      //   };
      // });
      // console.log(allTasks,"allTasks")
      // setTasks(allTasks);

      // // getIssueByTaskId(task.data.data._id);
    } else {
      setTasks([]);
      setShowLoader(false);
    }
  };

  const smoother = (item: any, status: string) => {
    let taskClone = [...tasks];
    const targated = taskClone.find((task: any) => task._id === item.id);
    const itemIndex = taskClone.findIndex((task: any) => task._id === item.id);
    taskClone.splice(itemIndex, 1, {...targated, status: status});
    setTasks(taskClone);
  };

  const modifiedTask =
    tasks &&
    tasks.map((task) => {
      if (task.status === 'Do it') {
        task.status = 'To do';
      }
      return task;
    });

 
  const archieveTaskFn = async (taskId: string, projectId: string, status: string) => {
    try{ 
      const { DONE } = COLUMN_NAMES;
      if(status !== DONE){
        return toast.error("You can only archive DONE tasks");
      }

      if(getUserPermission(user) !== 'admin'){
        return toast.error("Only admin can archive a task")
      }
      
      await archieveTask(taskId, projectId);
  
      const updatedTasks = tasks.filter((task:any) => task._id !== taskId);
      setTasks(updatedTasks)
      toast.success("Task archived successfully");
    }catch(error){
      toast.error("Error occurred while archiving the task")
    }
  }

  const searchHandler = () => {
    getTasks(searchValues);
  };

  const resetHandler = () => {
    setSearchText('');
    setPriority('');
    setUserId('');
    setProjectId('');
    getFirstProjectTasks();
  };

  const getFirstProjectTasks = async () => {
    setShowLoader(true);
    let myProrectsResp = {};

    if (getUserPermission(user) === 'admin') {
      myProrectsResp = await getAllProjectNames();
    } else {
      myProrectsResp = await getMyProjects();
    }

    handleStatus(myProrectsResp.status, () => dispatch(logoutUser()), navigate);

 
    if (myProrectsResp.status === 200) {
      const projectsArr = myProrectsResp.data.data;

      // if (projectsArr.length > 0) {
      //   const firstProject = projectsArr[0];
      //   setProjectId(firstProject._id);
      //   setUserId(loggedInId);

      const resp = await getUserAllIssues();
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      setShowLoader(false);
      if (resp.data.ok) {
   
        setTasks(resp.data.data);
        await setAttachmentsToTasks(resp.data.data);
        
      }
      // }
    }
   
  };

  useEffect(() => {
      getUsers();
      getProjects();
      getFirstProjectTasks();
  }, []);

  const moveCardHandler = (dragIndex: any, hoverIndex: any) => {
    const dragItem = tasks[dragIndex];

    if (dragItem) {
      setTasks((prevState: any) => {
        const coppiedStateArray = [...prevState];

        const prevItem = coppiedStateArray.splice(hoverIndex, 1, dragItem);

        coppiedStateArray.splice(dragIndex, 1, prevItem[0]);

        return coppiedStateArray;
      });
    }
  };

  const returnItemsForColumn = (columnName: any) => {
    return tasks
      .filter((item) => item.status === columnName)
      .map((item, index) => (
        <MovableItem
          id={item._id}
          attachments={item.attachments}
          assignedTo={item.assignedTo}
          taskNo={item.taskNo}
          title={item.title}
          priority={item.priority}
          projectId={item.projectId}
          status={item.status}
          setTasks={setTasks}
          index={index}
          estimateTime={item.estimateTime}
          moveCardHandler={moveCardHandler}
        />
      ));
  };

  const handleClose = () => {
    if (mode === 'CREATE') {
      setShow(false);
      return;
    }
    if (mode === 'UPDATE') {
      navigate('/tasks');
      setShow(false);
    }
  };

  const closeUpdateHandler = () => {
    setShowUpdate(false);
  };

  const goToUpdateHandler = (id: any, projectId: any) => {
    setShowUpdate(true);
    localStorage.setItem('TASKID', id);
    localStorage.setItem('TaskProjectId', projectId);
  };

  const gotoCreate = () => {
    setShow(true);
    setMode('CREATE');
  };

  const MovableItem = ({
    id,
    title,
    attachments,
    taskNo,
    assignedTo,
    index,
    priority,
    status,
    moveCardHandler,
    setTasks,
    projectId,
    estimateTime
  }) => {
    const changeItemColumn = (currentItem, status) => {
      setTasks((prevState) => {
        return prevState.map((e) => {
          return {
            ...e,
            column: e.title === currentItem.title ? status : e.status,
            id: e._id
          };
        });
      });
    };

    const ref = useRef(null);

    const [, drop] = useDrop({
      accept: 'Our first type',
      hover(item: any, monitor) {
        if (!ref.current) {
          return;
        }
        const dragIndex = item.index;
        const hoverIndex = index;
        if (dragIndex === hoverIndex) {
          return;
        }

        const hoverBoundingRect = ref.current?.getBoundingClientRect();

        const hoverMiddleY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        const clientOffset = monitor.getClientOffset();

        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }
        moveCardHandler(dragIndex, hoverIndex);
        item.index = hoverIndex;
      },
      drop: (item) => {
        return handleDrop(item);
      }
    });

    const handleDrop = (item: any) => {};

    const [{isDragging}, drag] = useDrag({
      item: {index, title, status, id, projectId, type: 'Our first type', estimateTime},
      end: (item, monitor) => {
        const dropResult = monitor.getDropResult();
        if (dropResult) {
          const {name} = dropResult;
          const {DO_IT, IN_PROGRESS, AWAITING_REVIEW, DONE} = COLUMN_NAMES;

         
          switch (name) {
            case IN_PROGRESS:
              changeItemColumn(item, IN_PROGRESS);
              break;
            case AWAITING_REVIEW:
              changeItemColumn(item, AWAITING_REVIEW);
              break;
            case DONE:
              changeItemColumn(item, DONE);
              break;
            case DO_IT:
              changeItemColumn(item, DO_IT);
              break;
            default:
              break;
          }
        }
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging()
      })
    });

    const opacity = isDragging ? 0.5 : 1;

    drag(drop(ref));

    const taskPriorty = (priority: any) => {
      if (priority === 'low') {
        return (
          <AiOutlineArrowDown
            title={priority}
            style={{fontSize: '16px', color: 'green'}}
          />
        );
      }
      if (priority === 'medium') {
        return (
          <AiOutlineArrowUp
            title={priority}
            style={{fontSize: '16px', color: 'orange'}}
          />
        );
      }
      if (priority === 'urgent') {
        return (
          <AiOutlineArrowUp
            title={priority}
            style={{fontSize: '16px', color: 'red'}}
          />
        );
      }
      return;
    };

    const getAttachmentHash = (attachments) => {
      if(!attachments){
        return null;
      }

      return attachments.length > 0 ? attachments[0].fileHash : null;
    }
 
    const attachment = getAttachmentHash(attachments)
    return (
      <div
        key={id}       
        ref={ref}
        className=""
        style={{
          padding: '10px 8px',
          boxShadow: '#091e4240 0px 1px 2px 0px',
          cursor: 'pointer',
          background: '#fff',
          transition: 'background 0.1s ease 0s',
          borderRadius: '3px',
          margin: '4px 0',
          opacity
        }}
      >
        <div  onClick={() => goToUpdateHandler(taskNo, projectId)}>

      
        <p
          className="text-wrap word-wrap"
          style={{
            fontSize: '16px',
            margin: '4px 0',
            paddingBottom: attachment ? '10px' : '50px'
          }}
        >
          {title}
        </p>
        {attachment ? (
          <img
            src={`${BASE_URL}/task/get-file?hash=${attachment}&token=${localStorage.getItem(
              'token'
            )}`}
            className='w-100'
            key={index}
            style={{margin: '2px'}}
            alt=""
          />
        ) : null}
          </div>
        <div className="d-flex aligin-items-center justify-content-between mt-1">
          <div className="d-flex justify-content-center align-items-center">
            {taskPriorty(priority)}
            <span className="ml-1"  >
              {taskNo}
            </span>
          </div>

          <div className="d-flex justify-content-center align-items-center">
            <div>
              {assignedTo.map((item) => (
                <img
                  src={item.profile}
                  width="20px"
                  height={'20px'}
                  key={item.profile}
                  style={{margin: '2px', borderRadius: '50%'}}
                  alt=""
                />
              ))}
            </div>
            <button onClick={() => archieveTaskFn(id, projectId, status)} className='border-0  bg-transparent'>
              <BsArchive
                style={{fontSize: '20px ', color: 'green', margin: '0 0 0 5px'}}
              />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const estimateExist = (estimateTime: string) => {
    const [hours=0, minutes=0] = estimateTime
    .split(/[hHmM]/)
    .filter(Boolean)
    .map(Number);

    const totalMins = minutes + ( 60 * hours);

    return totalMins > 0;

  }

  const Column = ({children, title}) => {    
    const [{isOver, canDrop}, drop] = useDrop({
      accept: 'Our first type',
      drop: async (item) => {
        smoother(item, title);
        await changeColumn(item.id, {status: title, projectId: item.projectId});
        return {name: title};
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
      }),
      canDrop: (item: any) => {
        const {DO_IT, IN_PROGRESS, AWAITING_REVIEW, DONE} = COLUMN_NAMES;
        const {status} = item;
       
        let res =
          status === title ||
          (status === DO_IT && title === IN_PROGRESS) ||
          (status === IN_PROGRESS &&
            (title === DO_IT || title === AWAITING_REVIEW)) ||
          (status === AWAITING_REVIEW &&
            (title === IN_PROGRESS || title === DONE)) ||
          (status === DONE && title === AWAITING_REVIEW);

        
        if (res) {
          // console.log(estimateExist(item.estimateTime),"************estiate time ")
          if(title === IN_PROGRESS && !estimateExist(item.estimateTime)){
           const localSetup = localStorage.getItem("toast"); 
           if(!localSetup){
            localStorage.setItem("toast", "true");
            toast.error("Please add estimate before moving task to IN PROGRESS. Make sure it's in right format eg 2h0m");
            setTimeout(() => localStorage.removeItem("toast") , 2000)
           }
            
            return false;
          }

          const copied = [...tasks];
          const modified = copied.map((task, index) => {
            if (task._id === item.id) {
              task.status = title;
            }
          });
        }
 
        return res;
      }
    });

    return (
      <div
        ref={drop}
        className="card d-flex flex-column"
        style={{background: '#f4f5f7', padding: '8px', width: '24%'}}
      >
        <h5 className="text-center" style={{fontSize: '16px'}}>
          {title ? title.toUpperCase() : ''}
        </h5>
        {children}
      </div>
    );
  };

  if (showLoader) {
    return <Loader title={'Daily'} />;
  }

  return (
    <Fragment>
      <ContentHeader title="Tasks" />
      {show && (
        <TaskForm
          onhide={handleClose}
          mode={mode}
          allUsers={allUsers}
          setShow={setShow}
          projects={projects}
          getTasks={getTasks}
          searchValues={searchValues}
        />
      )}
      {showUpdate && (
        <ViewUpdateTask
          show={showUpdate}
          onHide={closeUpdateHandler}
          getTasks={getTasks}
          searchValues={searchValues}
          projects={projects}
          allUsers={allUsers}
        />
      )}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">All About tasks</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex align-items-baseline">
                    <div className="w-100">
                      <div className="row d-flex align-items-center justify-content-between">
                        <div className="d-flex">
                          <div className="col-xs-3" style={{width: '180px'}}>
                            <input
                              type="text"
                              name="searchText"
                              className="form-control mx-1 my-2"
                              placeholder="Search Title"
                              onChange={(e) => setSearchText(e.target.value)}
                              value={searchText}
                            />
                          </div>
                          <div
                            className="col-xs-3  ml-2"
                            style={{width: '120px'}}
                          >
                            <select
                              name="projectId"
                              style={{width: '120px'}}
                              className="form-control mx-1 my-2"
                              value={projectId}
                              onChange={(e) => setProjectId(e.target.value)}
                            >
                              <option value="">-Select-</option>
                              {projects.map((project, index) => (
                                <option key={index} value={project._id}>
                                  {project.projectName}
                                </option>
                              ))}
                            </select>
                          </div>
                          {getUserPermission(user) === 'admin' ? (
                            <div
                              className="col-xs-3  ml-2"
                              style={{width: '120px'}}
                            >
                              <select
                                name="assignedUser"
                                className="form-control mx-1 my-2"
                                value={userId}
                                onChange={(e) => setUserId(e.target.value)}
                              >
                                <option value="">Assigned Users</option>
                                {allUsers.map((values, index) => (
                                  <option key={index} value={values.value}>
                                    {values.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ) : null}
                          <div
                            className="col-xs-3  ml-2"
                            style={{width: '120px'}}
                          >
                            <select
                              className="form-control mx-1 my-2"
                              name="priority"
                              onChange={(e) => setPriority(e.target.value)}
                              value={priority}
                            >
                              <option value="">Priority</option>
                              {priorties.map((p, idx) => (
                                <option key={idx} value={p.toLowerCase()}>
                                  {p}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="d-flex">
                          {projects.length !== 0 && (
                            <>
                              <div className="col-xs">
                                <Button
                                  type="button"
                                  className=" my-2 mx-1"
                                  variant="primary"
                                  onClick={searchHandler}
                                >
                                  Search
                                </Button>
                              </div>
                              <div className="col-xs">
                                <Button
                                  type="button"
                                  className=" my-2 mx-1"
                                  variant="primary"
                                  onClick={resetHandler}
                                >
                                  Reset
                                </Button>
                              </div>
                              <div className="col-xs">
                                <Button
                                  type="button"
                                  className="my-2 mx-1"
                                  variant="primary"
                                  onClick={() => gotoCreate()}
                                >
                                  CREATE
                                </Button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body w-100 py-2 px-0">
                    {tasks.length === 0 ? (
                      <h1 className="text-center">No Task Found</h1>
                    ) : (
                      <div className="d-flex flex-row justify-content-around">
                        <DndProvider
                          backend={isMobile ? TouchBackend : HTML5Backend}
                        >
                          <Column id={DO_IT} title={DO_IT}>
                            {returnItemsForColumn(DO_IT)}
                          </Column>
                          <Column id={IN_PROGRESS} title={IN_PROGRESS}>
                            {returnItemsForColumn(IN_PROGRESS)}
                          </Column>
                          <Column id={AWAITING_REVIEW} title={AWAITING_REVIEW}>
                            {returnItemsForColumn(AWAITING_REVIEW)}
                          </Column>
                          <Column id={DONE} title={DONE}>
                            {returnItemsForColumn(DONE)}
                          </Column>
                        </DndProvider>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default React.memo(Tasks);
